import React from "react";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

const ToastWrapper = () => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <ToastContainer
      position={isArabic ? "top-left" : "top-right"}
      autoClose={2000}
      hideProgressBar
      rtl={isArabic}
      className={isArabic ? "toast-ar" : ""}
    />
  );
};

export default ToastWrapper;
